import { Address } from './address.model';

export class VoteLocation {
    notes: string;
    lastVoteComment: string;
    personInfo: string;
    lastVoteParty: string;
    address: Address;
    id: string;
   constructor() {
   }
}



// WEBPACK FOOTER //
// ./src/app/models/vote.location.model.ts